<template>
  <div class="label-size-menu">
    <input
      :value="value"
      type="number"
      min="1"
      :max="MAX_FONT_SIZE"
      class="label-size-input"
      data-testid="label-size-input"
      @change="$emit('input', ($event.target as HTMLInputElement).value)"
    />
  </div>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue'
import { MAX_FONT_SIZE } from '~/lib/constants/labels'

defineProps({
  value: {
    type: Number as PropType<number>,
    required: true,
  },
})

defineEmits(['input'])
</script>

<style lang="stylus" scoped>
.label-size-menu
  @apply flex-grow h-full flex items-center justify-center py-4 px-3 min-w-0

.label-size-input
  @apply bg-white text-gray-750 py-1 pl-2 pr-1 text-xs focus_outline-none min-w-0 w-full rounded-md
</style>
